module.exports = __webpack_public_path__ + "img/cww_11.45f90502.jpg";